<template>
    <v-container v-if="period">
        <v-card
            v-if="period.content"
            class="mb-4"
        >
            <v-card-title>Konten</v-card-title>
            <v-card-text>
                <div
                    v-html="content"
                    class="body-2"
                ></div>
            </v-card-text>
        </v-card>

        <period-kelon
            v-if="period.kelon_group_id"
            :period="period"
            class="mb-4"
        ></period-kelon>

        <period-tryout v-if="!period.is_content_registration"></period-tryout>
    </v-container>
</template>

<script>
import PeriodTryout from './components/PeriodTryout.vue'
import PeriodKelon from './components/PeriodKelon.vue'
import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import TextAlign from '@tiptap/extension-text-align'
import { generateHTML } from '@tiptap/html'

export default {
    components: {
        PeriodTryout,
        PeriodKelon,
    },

    data() {
        return {
            period: null,
        }
    },

    computed: {
        content() {
            if (!this.period.content) {
                return null
            }

            return generateHTML(JSON.parse(this.period.content), [
                StarterKit,
                Link,
                TextAlign.configure({
                    types: ['paragraph'],
                }),
            ])
        },
    },

    async created() {
        const response = await this.$api.get(
            `period/${this.$route.params.period_id}`,
            { loader: 'appbar' }
        )

        this.period = response.data
        this.$store.set('ui/title', response.data.title)
    },
}
</script>
